import React, { useEffect, Suspense, lazy } from 'react';
// import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import Navbar from 'components/Navbar/Navbar';
import MyAlert from 'components/Alert/Alert';
import Home from './views/Home/Home';
import {
  DASHBOARD,
  HOME,
  LOGIN,
  MANAGE_ACOUNT,
  MY_FRIENDS,
  MY_PROFILE,
  REGISTER,
  RESET_PASSWORD,
  USER_PROFILE,
  VIEW_POST,
  CREATE_POST,
  MY_POSTS,
  USER_POSTS,
  EDIT_POST,
  MESSAGE_REQUESTS,
  LEADERBOARD,
  CHAT,
  CREATE_STREAM,
  STREAM_INSTRUCTION,
  WATCH_STREAM,
  WATCH_USER_STREAM,
  WATCH_GAMER_STREAM,
} from './constants/routes';
import { loadUser } from 'slices/authSlice';
import setAuthToken from 'utils/setAuthToken';
import {
  createMuiTheme,
  responsiveFontSizes,
  MuiThemeProvider,
} from '@material-ui/core';
import Loader from 'components/Loader/Loader';
import Footer from 'components/MaterialKit/Footer/Footer';
import Login from 'views/auth/Login/Login';
import Register from 'views/auth/Register/Register';
import ResetPassword from 'views/auth/ResetPassword/ResetPassword';
import PrivateRoute from 'components/PrivateRoute';
import Post from 'views/Post/Post';

const Dashboard = lazy(() => import('./views/Dashboard/Dashboard'));

const ManageAccount = lazy(() =>
  import('views/auth/ManageAccount/ManageAccount')
);
const Profile = lazy(() => import('views/Profile/Profile'));
const UserProfile = lazy(() => import('views/Profile/UserProfile'));
const Friends = lazy(() => import('views/Profile/Friends/Friends'));

const CreatePost = lazy(() =>
  import('./views/Post/CreateOrUpdatePost/CreateOrUpdatePost')
);
const MyPosts = lazy(() => import('views/Post/MyPosts'));
const UserPosts = lazy(() => import('views/Post/UserPosts'));
const MessageRequests = lazy(() =>
  import('views/Profile/MessageRequests/MessageRequests')
);
const LeaderBoard = lazy(() =>
  import('views/Dashboard/LeaderBoard/LeaderBoard')
);

const Chat = lazy(() => import('views/Profile/Chat/components/Chat'));
const CreateStream = lazy(() =>
  import('views/Profile/LiveStream/CreateStream/CreateStream')
);
const StreamInstructions = lazy(() =>
  import('views/Profile/LiveStream/StreamInstructions/StreamInstructions')
);

const WatchStreamUser = lazy(() =>
  import('views/Profile/LiveStream/WatchStream/WatchStreamUser')
);
const WatchStreamGamer = lazy(() =>
  import('views/Profile/LiveStream/WatchStream/WatchStreamGamer')
);
const NotFound = lazy(() => import('components/NotFound'));

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const App = (props) => {
  useEffect(() => {
    (async () => {
      if (localStorage.token) {
        await setAuthToken(localStorage.token);
        store.dispatch(loadUser());
      }
    })();
  }, []);

  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <Router>
          <MyAlert />
          <Suspense fallback={<Loader />}>
            <Navbar />
            <Switch>
              <Route exact path={HOME}>
                <Home />
              </Route>
              <Route exact path={LOGIN}>
                <Login />
              </Route>
              <Route exact path={REGISTER}>
                <Register />
              </Route>
              <Route exact path={RESET_PASSWORD}>
                <ResetPassword />
              </Route>
              <PrivateRoute exact path={DASHBOARD}>
                <Dashboard />
              </PrivateRoute>
              <PrivateRoute exact path={MANAGE_ACOUNT}>
                <ManageAccount />
              </PrivateRoute>
              <PrivateRoute exact path={MANAGE_ACOUNT}>
                <ManageAccount />
              </PrivateRoute>
              <PrivateRoute exact path={MY_PROFILE}>
                <Profile />
              </PrivateRoute>
              <PrivateRoute exact path={USER_PROFILE}>
                <UserProfile />
              </PrivateRoute>
              <PrivateRoute exact path={USER_POSTS}>
                <UserPosts />
              </PrivateRoute>
              <PrivateRoute exact path={MY_FRIENDS}>
                <Friends />
              </PrivateRoute>
              <PrivateRoute exact path={MESSAGE_REQUESTS}>
                <MessageRequests />
              </PrivateRoute>
              <PrivateRoute exact path={LEADERBOARD}>
                <LeaderBoard />
              </PrivateRoute>
              <PrivateRoute exact path={MY_POSTS}>
                <MyPosts />
              </PrivateRoute>
              <PrivateRoute exact path={CREATE_POST}>
                <CreatePost />
              </PrivateRoute>
              <PrivateRoute exact path={VIEW_POST}>
                <Post />
              </PrivateRoute>
              <PrivateRoute exact path={EDIT_POST}>
                <CreatePost />
              </PrivateRoute>
              <PrivateRoute exact path={CHAT}>
                <Chat />
              </PrivateRoute>
              <PrivateRoute exact path={CREATE_STREAM}>
                <CreateStream />
              </PrivateRoute>
              <PrivateRoute exact path={STREAM_INSTRUCTION}>
                <StreamInstructions />
              </PrivateRoute>
              <PrivateRoute exact path={WATCH_USER_STREAM}>
                <WatchStreamUser />
              </PrivateRoute>
              <PrivateRoute exact path={WATCH_GAMER_STREAM}>
                <WatchStreamGamer />
              </PrivateRoute>
              <Route exact path='*'>
                <NotFound />
              </Route>
            </Switch>
            <Footer />
          </Suspense>
        </Router>
      </MuiThemeProvider>
    </Provider>
  );
};

App.propTypes = {};

export default App;
